export function replaceDomain(url) {
  const newDomain = "https://d1ytcm2rfo0yep.cloudfront.net";

  const urlObj = new URL(url);
  return newDomain + urlObj.pathname;
}
